import { Factory } from '../../services/Factory';

export interface IButtonDropdownScope extends angular.IScope {
  selectedValue: any;
  selectedOption: any;
  options: any[];
  selectOption: (index: number) => void;
  serviceUrl: string;
  placeholderText: string;
}

export interface IButtonDropdownAttributes extends angular.IAttributes {
  selectedIndex: number;
}

export class ButtonDropdown implements angular.IDirective {
  public restrict:string = 'E';
  public link:(scope: IButtonDropdownScope, element: angular.IAugmentedJQuery, attrs: IButtonDropdownAttributes) => void;
  public templateUrl:string;
  public scope = { selectedValue:'=ngModel', options:'=' };
  public require = ['ngModel'];

  constructor() {
    this.templateUrl = 'partials/controls/button_dropdown.html';
    this.link = (scope: IButtonDropdownScope, element: angular.IAugmentedJQuery, attrs: IButtonDropdownAttributes) => {
      scope.selectOption = (index: number) => {
        scope.selectedOption = scope.options[index];
      };
      scope.selectedOption = scope.options[attrs.selectedIndex ? attrs.selectedIndex : 0];
      scope.$watch("selectedOption", (selectedOption: any) => {
        if (selectedOption) {
          scope.selectedValue = selectedOption.value;
        }
      });
    }
  }
}

frontendApp.directive("iioButtonDropdown", [Factory.Create(ButtonDropdown)]);
